import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { useDispatch } from 'react-redux';
import { logout } from 'src/store/slices/userSlice';
import { requiresTermsAcceptance } from 'src/utils/services';

//
import { useAuthContext } from '../hooks';
import { useMockedUser } from 'src/hooks/use-mocked-user';


// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const {user}=useMockedUser();
  const {method } = useAuthContext();
  const [checked, setChecked] = useState(false);
  const check = useCallback(() => {
    // if (!user?.token) {
    if (!user) {
      router.replace('/login');
    } else if (requiresTermsAcceptance(user)) {
      // Session stored before the terms were accepted: drop it and hand it to
      // the terms page, which stores it again on accept.
      dispatch(logout());
      router.push(paths.acceptTerms, { replace: true, state: { email: user.email, user } });
    } else {
      setChecked(true);
    }
  }, [user, method, router]);


  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};
